/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AiSummaryConfig
 */
export interface AiSummaryConfig {
    /**
     * 
     * @type {boolean}
     * @memberof AiSummaryConfig
     */
    enabled: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AiSummaryConfig
     */
    rewriteTitle?: boolean;
}

export function AiSummaryConfigFromJSON(json: any): AiSummaryConfig {
    return AiSummaryConfigFromJSONTyped(json, false);
}

export function AiSummaryConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): AiSummaryConfig {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
        'rewriteTitle': !exists(json, 'rewriteTitle') ? undefined : json['rewriteTitle'],
    };
}

export function AiSummaryConfigToJSON(value?: AiSummaryConfig | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
        'rewriteTitle': value.rewriteTitle,
    };
}

